import { Col, ConfigProvider, DatePicker, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import React, { useEffect, useState } from 'react'
import { LOGGED_USER } from '../../../../variables/constants';
import PreviewPrimes from './PreviewPrimes';
import frFR from 'antd/locale/fr_FR';
import dayjs from 'dayjs';
import { rightsService } from '../../../../services/rightsService';
import axiosInstance from '../../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';
import { displayNumbers } from '../../../../variables/numbersFunctions';
import { useParams } from 'react-router-dom';

const GarantiesForm = ({ categorie, selectedCategorie, fractionnements, preview, fractionnementSelect, setFractionnementSelect, dateEffet, setDateEffet, sameYear, loadingPreview, tauxCommission, setTauxCommission, agencyProduction, setAgencyProduction }) => {
    const [formGaranties] = Form.useForm();
    const [selectedCompany, setSelectedCompany] = useState(JSON.parse(sessionStorage.getItem("currentCompagnie"))?.code || "");
    const [selectedIntermediaire, setSelectedIntermediaire] = useState(null);
    const [tc, setTC] = useState(0);
    const [courtiers, setCourtiers] = useState([]); // à récupérer via API
    const [intermediaires, setIntermediaires] = useState([]); // à récupérer via API
    const [agences, setAgences] = useState([]); // à récupérer via API

    const param = useParams();

    const getSimpleAgencies = () => {
        let agencies = [];
        agencies = agences.filter((a) => a.typeAgence !== "COURTIER");
        return agencies;
    };

    const handleCourtierChange = (e) => {
        setSelectedCompany(e);
    };

    const handleAgenceChange = (value) => {
        let ag = agences.find((el) => el.codeAgence === value);
        if (ag && ag.typeAgence !== "COURTIER") {
            getIntermediairesByAgency(value);
        } else {
            setIntermediaires([]);
            ag = courtiers.find((el) => el.codeAgence === value);
            getTauxCommissionByCourtierAndCodeCategorie(
                value,
                LOGGED_USER.profil.organisme.code
            );
        }
        setAgencyProduction(ag);
    };

    const getIntermediairesByAgency = (codeAgence) => {
        axiosInstance
            .get(`/api/intermediaire/compagnie/${codeAgence}`)
            .then((res) => {
                setIntermediaires(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getTauxCommissionByCourtierAndCodeCategorie = (
        codeAgence,
        codeCompagnie
    ) => {
        axiosInstance
            .get(
                `/api/agence/taux-commission/${codeAgence}/${selectedCategorie}/${codeCompagnie}`
            )
            .then((res) => {
                console.log("taux-commission-fetched: ", res.data);
                if (!res.data) {
                    toast(
                        "Taux de commission non encore défini pour cette catégorie pour le courtier"
                    );
                }
                res.data && setTauxCommission(res.data);
                res.data && setTC(res.data);
                formGaranties.setFieldsValue({ tauxCommission: res.data });
            })
            .catch((err) => {
                console.log(err);
                toast(
                    "Taux de commission non encore défini pour cette catégorie pour le courtier"
                );
            });
    };

    const getTauxCommissionByIntermediaireAndCodeCategorie = (
        codeIntermediaire, codeCompagnie
    ) => {
        axiosInstance
            .get(`/api/intermediaire/taux-commission/${codeIntermediaire}/${categorie}/${codeCompagnie}`)
            .then((res) => {
                console.log("taux-commission-fetched: ", res.data);
                res.data && setTauxCommission(res.data);
                res.data && setTC(res.data);
                formGaranties.setFieldsValue({ tauxCommission: res.data });
            })
            .catch((err) => {
                console.log(err);
                toast(
                    "Taux de commission non encore défini pour cette catégorie pour ce courtier"
                );
            });
    };

    const handleIntermediaireChange = (e) => {
        getTauxCommissionByIntermediaireAndCodeCategorie(e.target.value, LOGGED_USER.profil.organisme.code);
        setSelectedIntermediaire(e.target.value);
    };

    const disabledDate = (current) => {
        return current && current < dayjs().startOf('day');
    };

    const getDateEcheance = (date) => {
        setDateEffet(date);
    };

    useEffect(() => {
        axiosInstance
            .get(
                `/api/agence/organisme/code/${LOGGED_USER?.profil?.organisme?.code}`
            )
            .then((res) => {
                console.log("Agences: ", res.data);
                setAgences(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        // Récupération des courtiers
        axiosInstance
            .get(`/api/agence/all/courtiers`)
            .then((res) => {
                console.log("Courtiers: ", res.data);
                setCourtiers(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(
                `/api/intermediaire/compagnie/actifs/${LOGGED_USER?.profil?.organisme?.code}`
            )
            .then((res) => {
                setIntermediaires(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        if (LOGGED_USER?.agence?.typeAgence === "COURTIER" && selectedCategorie) {
            getTauxCommissionByCourtierAndCodeCategorie(
                LOGGED_USER.agence?.codeAgence,
                JSON.parse(sessionStorage.getItem("currentCompagnie"))?.code
            );
            console.log("selectedCategorie: ", JSON.parse(sessionStorage.getItem("currentCompagnie"))?.code);
            setSelectedCompany(
                JSON.parse(sessionStorage.getItem("currentCompagnie"))?.code ||
                ""
            );
        }
    }, [selectedCategorie]);

    useEffect(() => {
        formGaranties.setFieldValue("fractionnement", fractionnementSelect);
    }, [fractionnementSelect]);


    return (
        <div className="row g-6">
            <div className="col-12">
                <Form form={formGaranties} layout="vertical"
                    initialValues={{
                        fractionnement: fractionnementSelect || "",
                        dateEffet: dateEffet || dayjs(),
                        company: JSON.parse(sessionStorage.getItem("currentCompagnie"))?.code || LOGGED_USER?.profil?.organisme?.code || "",
                        tauxCommission: tauxCommission || 0,
                    }}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Durée"
                                name="fractionnement"
                            >
                                <Select
                                    placeholder="1 an"
                                    onChange={(val) => {
                                        // conserve l'état existant et met à jour preview
                                        setFractionnementSelect(val || "");
                                        formGaranties.setFieldsValue({ fractionnement: val });
                                    }}
                                    allowClear
                                >
                                    <Select.Option value="">1 an</Select.Option>
                                    {!sameYear ? fractionnements && fractionnements?.map((fra) => fra.nombre !== 1 ? (
                                        <Select.Option key={fra.fractionnementId} value={fra.fractionnementId}>
                                            {fra.moisMin} {fra.periode || "Mois"}
                                        </Select.Option>
                                    ) : null) : null}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            {LOGGED_USER?.agence?.typeAgence === "COURTIER" ? (
                                <Form.Item label="Compagnie (Courtier)" name="company" rules={[{ required: true, message: "Sélectionnez la compagnie" }]}>
                                    <Select
                                        placeholder="Sélectionnez la compagnie"
                                        // value={selectedCompany || ""}
                                        onChange={(val) => {
                                            setSelectedCompany(val);
                                            handleCourtierChange({ target: { value: val } });
                                        }}
                                        disabled={LOGGED_USER?.agence?.typeAgence === "COURTIER"}
                                    >
                                        {LOGGED_USER?.agence?.validAgrements?.map((agr) => (
                                            <Select.Option key={agr.compagnie.code} value={agr.compagnie.code}>
                                                {agr?.compagnie?.raisonSociale}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            ) : (
                                <Form.Item label="Vous produisez pour" name="agence" rules={[{ required: true, message: "Sélectionnez l'agence / courtier" }]}>
                                    <Select
                                        placeholder="Sélectionnez l'agence / courtier"
                                        onChange={(val) => handleAgenceChange(val)}
                                        defaultValue={param?.contratId && agencyProduction ? agencyProduction?.nom : LOGGED_USER?.agence?.nom}
                                        options={[
                                            {
                                                label: <span>Agence</span>,
                                                title: 'agence',
                                                options: getSimpleAgencies()?.map((a) => rightsService("HLA068") ? ({
                                                    label: a.nom, value: a.codeAgence, key: `ag_${a.codeId}`
                                                }) : (LOGGED_USER?.agence?.codeAgence === a.codeAgence && {
                                                    label: a.nom, value: a.codeAgence, key: `agu_${a.codeId}`
                                                })).filter(Boolean)
                                            },
                                            {
                                                label: <span>Courtier</span>,
                                                title: 'courtier',
                                                options: courtiers && courtiers.map((c) => ({ label: c.nom, value: c.codeAgence, key: `co_${c.codeId}` }))
                                            },
                                        ]}
                                    />
                                </Form.Item>
                            )}
                        </Col>

                        {intermediaires && intermediaires?.length ? <Col span={12}>
                            <Form.Item label="Intermédiaire" name="intermediaire">
                                <Select
                                    placeholder="Sélectionnez l'intermédiaire (optionnel)"
                                    value={selectedIntermediaire || undefined}
                                    onChange={(val) => {
                                        setSelectedIntermediaire(val);
                                        handleIntermediaireChange({ target: { value: val } });
                                    }}
                                >
                                    {intermediaires && intermediaires.map((inter) => (
                                        <Select.Option key={inter.codeIntermediaire} value={inter.codeIntermediaire}>
                                            {inter?.personne?.nom} {inter?.personne?.prenom}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col> : null}

                        {intermediaires?.length || LOGGED_USER?.agence?.typeAgence === "COURTIER" || agencyProduction?.typeAgence === "COURTIER" ?
                            <Col span={12}>
                                <Form.Item label="Taux de commission" name="tauxCommission">
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        // value={tc}
                                        onChange={(val) => { setTauxCommission(Number(val || 0)); setTC(Number(val || 0)) }}
                                        min={0}
                                        max={100}
                                        disabled={LOGGED_USER?.agence?.typeAgence === "COURTIER"}
                                    />
                                </Form.Item>
                            </Col> : null}

                        <Col span={12}>
                            <Form.Item label="Accessoires">
                                <Input value={displayNumbers(preview?.accessoires) || 0} disabled />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="Date effet *"
                                name="dateEffet"
                                rules={[{ required: true, message: "La date d'effet est requise" }]}
                            >
                                <ConfigProvider locale={frFR}>
                                    <DatePicker
                                        showTime
                                        style={{ width: "100%" }}
                                        disabledDate={disabledDate}
                                        value={dateEffet || dayjs()}
                                        onChange={(val) => {
                                            setDateEffet(val);
                                            formGaranties.setFieldsValue({ dateEffet: val });
                                            getDateEcheance(val);
                                        }}
                                    />
                                </ConfigProvider>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <div className="container">
                                <Spin spinning={loadingPreview}>
                                    <PreviewPrimes preview={preview} />
                                </Spin>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    )
}

export default GarantiesForm